export const HEADER_COLLAPSE_WIDTH = 700;

export function shouldCollapseHeaderLabels(width) {
  return Number(width) > 0 && Number(width) < HEADER_COLLAPSE_WIDTH;
}
